"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateBookCoverPrintable;
// Third party imports
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
// Project imports
const designs_1 = require("../designs");
const numbers_1 = require("../../helpers/numbers");
const layers_1 = require("../layers");
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const Product_1 = require("../../models/Product");
/**
 * Creates an updated copy of the given cover printable with the appropriate surface & layers
 * attributes based on the given interior page count.
 *
 * If the given template doesn't have any coverSurfaces, this method does nothing; it will just
 * return the original printable.
 *
 * @param template Template to use.
 * @param coverPrintable Printable to update.
 * @param interiorPageCount Number of interior pages in the book project of the printable.
 * @param updateTimestamp Value to set the 'lastModifiedAt' of the new printable to.
 * @param designId Id of the design to look & use. If not provided, the design id on current
 *  printable is used.
 * @returns An updated copy of the original printable, or an error if something went wrong.
 */
function updateBookCoverPrintable(template, coverPrintable, interiorPageCount, updateTimestamp, designId, hammerCategory) {
  // If there aren't any cover surfaces on the template, then there isn't anything to do.
  // Just return the given printable.
  if (!template.coverSurfaces) {
    return (0, either_1.right)(coverPrintable);
  }
  const newCoverPrintable = (0, Printable_1.updatePrintableVersion)(coverPrintable, updateTimestamp);
  // Look for the appropriate coverSurface based on the interior page count of the book
  const newCoverSurface = template.coverSurfaces.find(coverSurf => coverSurf.pageCount && (0, numbers_1.inRange)(interiorPageCount, coverSurf.pageCount.min, coverSurf.pageCount.max));
  if (!newCoverSurface) {
    return (0, either_1.left)(new Error(`Could not find cover surface for page count = ${interiorPageCount}`));
  }
  // Add the coverSurface that was found to the cover printable
  newCoverPrintable.surface = (0, lodash_clonedeep_1.default)(newCoverSurface);
  // Find the appropriate design based on the interior page count
  // (this doesn't get added to the printable, but it's used to find the appropriate layers)
  const interiorPrintableCount = (0, Product_1.isSpreadBooksCategory)(hammerCategory) ? interiorPageCount / 2 : interiorPageCount;
  const findCoverDesignResult = (0, designs_1.findCoverDesign)(template.designs, interiorPrintableCount, designId || coverPrintable.designId);
  if (findCoverDesignResult.isLeft()) {
    return (0, either_1.left)(findCoverDesignResult.value);
  }
  // Get the layers based on the design
  const getLayersForDesignResult = (0, designs_1.findLayersInTemplate)(template, findCoverDesignResult.value);
  if (getLayersForDesignResult.isLeft()) {
    return (0, either_1.left)(getLayersForDesignResult.value);
  }
  // Add the layers to the printable
  newCoverPrintable.layers = (0, layers_1.updatePrintableDesignLayers)({
    oldSurface: coverPrintable.surface,
    newSurface: newCoverPrintable.surface,
    workspaceRotatedForPrintable: false,
    existingPrintableLayers: coverPrintable.layers,
    newTemplateLayers: getLayersForDesignResult.value
  });
  return (0, either_1.right)(newCoverPrintable);
}